import { AxiosInstance } from 'axios';

export const SOLUTIONS_ROOT = `solutionapi/services/v1`;

export const getSolutions = async (client: AxiosInstance) =>
    (await client.get(`${SOLUTIONS_ROOT}/experiences`)).data.solutions[0];
